document.addEventListener('DOMContentLoaded', () => {

  function setupModal(
    modalSelector,
    openSelector,
    closeSelector
  ) {
    const modal = document.querySelector(modalSelector);

    if (!modal) return;

    const openButtons = document.querySelectorAll(openSelector);
    const closeButtons = document.querySelectorAll(closeSelector);

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        modal.showModal();
        document.body.classList.add('modal-open');
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        modal.close();
      });
    });

    modal.addEventListener('close', () => {
      document.body.classList.remove('modal-open');
    });

    modal.addEventListener('click', (event) => {
      const rect = modal.getBoundingClientRect();

      const isInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.bottom &&
        rect.left <= event.clientX &&
        event.clientX <= rect.right;

      if (!isInDialog) {
        modal.close();
      }
    });
  }

  setupModal(
    '#LocalDeliveryModal',
    '[data-local-delivery-modal-open]',
    '[data-local-delivery-modal-close]'
  );

  setupModal(
    '#MessageCardModal',
    '[data-message-card-modal-open]',
    '[data-message-card-modal-close]'
  );

});